/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import {
  Marker as ReactGoogleMapsMarker,
  MarkerProps as ReactGoogleMapsMarkerProps,
} from "@react-google-maps/api";

import markerImage from "@img/map-pin-marker.png";

export interface GoogleMapMarkerProps extends ReactGoogleMapsMarkerProps {
  isOpen?: boolean;
  onOpenFnc?: any;
}

const GoogleMapMarker: React.FC<GoogleMapMarkerProps> = ({
  children,
  isOpen,
  ...props
}) => {
  const icon: google.maps.Icon = {
    url: markerImage,
    anchor: new google.maps.Point(30, 35),
  };
  const options: google.maps.MarkerOptions = {
    icon,
    anchorPoint: new google.maps.Point(3, -20),
  };

  return (
    <ReactGoogleMapsMarker options={options} {...props}>
      {children}
    </ReactGoogleMapsMarker>
  );
};

GoogleMapMarker.defaultProps = {};

export { GoogleMapMarker };
